import Select from "react-select";
import { connect } from "react-redux";
import { ControlLabel, FormGroup } from "react-bootstrap";
import React, { Component } from "react";
import { actions, Errors } from "react-redux-form";

import _ from "lodash";
import "./searchable-select.css";

class SearchableSelect extends Component {
  state = { value: "", options: [] };

  componentDidMount() {
    if (this.props.model && this.props.required) {
      this.props.dispatch(actions.setValidity(this.props.model, false));
    }
    if (this.props.options && this.props.value !== undefined) {
      this.setState({
        options: this.props.options,
        value: this.props.value,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { options, value } = this.props;
    const { model, dispatch } = this.props;

    if (prevProps.value !== value || !_.isEqual(prevProps.options, options)) {
      this.setState({
        options,
        value,
      });

      if (model) {
        dispatch(actions.change(model, value));
      }
    }
  }

  handleChange(option) {
    const { model, dispatch } = this.props;
    const value = option ? option.value : "";

    dispatch(actions.change(model, value));
    if (this.props.onChange && this.props.onChange !== undefined) {
      this.props.onChange(value);
    }
    this.handleError(value);
  }

  handleError = (val) => {
    const { model, dispatch, required } = this.props;
    const value = val || this.state.value;

    if (value === "" && required) {
      dispatch(actions.setValidity(model, false));
      dispatch(actions.setErrors(model, { required: true }));
    } else {
      dispatch(actions.setValidity(model, true));
      dispatch(actions.setErrors(model, { required: false }));
    }
  };

  render() {
    return (
      <FormGroup className="select-formgroup" controlId={this.props.controlId}>
        {this.props.label && (
          <ControlLabel>
            {this.props.label}
            {this.props.required && "*"}
          </ControlLabel>
        )}
        <Select
          className="form-control"
          cache={false}
          isClearable
          searchable
          closeOnSelect
          disabled={this.props.disabled}
          onChange={(option) => this.handleChange(option)}
          options={this.state.options}
          placeholder={this.props.placeholder || "Select one..."}
          value={this.state.value}
          onBlur={(val) => this.handleError(val.target.value)}
        />

        <Errors
          className="errors"
          messages={
            this.props.messages || { required: "This field is required" }
          }
          model={this.props.model}
          show
        />
      </FormGroup>
    );
  }
}

export default connect()(SearchableSelect);



// WEBPACK FOOTER //
// ./src/components/common/form/elements/searchable-select.jsx